module.exports = __webpack_public_path__ + "static/media/1_A1_08.296d0e13.png";